module.exports = __webpack_public_path__ + "img/Trae Coyle.2398f031.png";